module.exports = __webpack_public_path__ + "media/images/empty-proposal-d2ef763ac26b8a2f24e3307c3e6fbb60.png";